import React from 'react'
import { Col, Row } from 'react-bootstrap'
import AnnouncementListItem from './AnnouncementListItem'

export default function AnnouncementList({ announcements, onDelete, onSend }) {
  return (
    <>
      {announcements.map((announcement, i) => (
        <Row key={i} className="pt-2 pb-2 border-bottom">
          <Col>
            <AnnouncementListItem announcement={announcement} onDelete={onDelete} onSend={onSend} />
          </Col>
        </Row>
      ))}
    </>
  )
}
